import * as constants from './constants';

type CookieProps = {
  [key: string]: string | null;
};

export default function buildCookieObject(cookieString?: string) {
  if (!cookieString) return null;
  // TS handles the type check, but we still have a lot of JS codebases using this library
  if (typeof cookieString !== 'string') {
    throw new TypeError('Cookie must be a string.');
  }
  const rawProps = cookieString.split(constants.PAIR_SEPARATOR);
  const props: CookieProps = {};
  rawProps.forEach((prop) => {
    if (prop.includes(constants.KEY_VALUE_SEPARATOR)) {
      const [key, value] = prop.split(constants.KEY_VALUE_SEPARATOR);
      props[key] = decodeURIComponent(value);
    } else {
      props[prop] = null;
    }
  });
  return props;
}
